/** Public seller profile attached to listings. */
export interface SellerPublicSummary {
  verification_level: number
  display_name: string
  member_since?: string | null
  completed_deals_count: number
  rating_avg?: number | null
  rating_count: number
  is_verified_seller: boolean
}

export type SellerBadgeLevelKey = 'level0' | 'level1' | 'level2' | 'level3'

export function sellerBadgeLevelKey(level: number): SellerBadgeLevelKey {
  if (level >= 3) return 'level3'
  if (level >= 2) return 'level2'
  if (level >= 1) return 'level1'
  return 'level0'
}

export function formatMemberSince(
  iso: string | null | undefined,
  locale: string,
): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString(locale, { year: 'numeric', month: 'short' })
}

export function formatSellerDealsCount(count: number): string {
  const n = Math.max(0, Math.floor(count))
  return String(n)
}
